// Mount the Eagle module: hand `createEagleModule` a lazy host (`./eagle-host`, which holds the
// service-scoped CDN analytics hooks) instead of a built one. `service-modules.ts` and
// `service-scopes.ts` take the CDN-provider console and the catalog scope from HERE, so the module
// cannot be mounted unregistered. This file must stay light: it is in the entry chunk. The HTTP
// clients are not members: the module reads them from the shared registry
// (`@vnetwork/margarita-core/http`).
import { createEagleModule } from '@vnetwork/margarita-eagle';

export const eagle = createEagleModule(() => import('./eagle-host').then((m) => m.eagleHost));
